module.exports = __webpack_public_path__ + "img/dingguofang.bebe51b1.png";